import { describeBulkError, type BulkErrorTranslators } from "@/lib/bulk/bulkErrorMessage";
import { describeBatchUpdateError } from "@/lib/i18n/translateBackendError";

/**
 * A refused GUEST bulk action, in words (M-97, plan graceful-giggling-melody).
 *
 * The guest batch lanes (archive / unarchive / delete / edit by id) answer a
 * refusal with `batchUpdatePartialFailure` and the reason PER ROW. Read as a
 * plain bulk error that is "Some guests could not be saved." for every reason
 * there is. With per-row codes the rows speak (describeBatchUpdateError), with
 * the bulk sentence as the fallback for a code without copy; without them it
 * is the ordinary bulk sentence (timeouts, field-gate refusals, tokens).
 */
export function describeGuestBulkError(err: unknown, translators: BulkErrorTranslators): string {
  const bulk = describeBulkError(err, translators);
  const failures =
    err && typeof err === "object" ? (err as { failures?: unknown }).failures : undefined;
  const hasRowCodes =
    Array.isArray(failures) &&
    failures.some(
      (f) => !!f && typeof f === "object" && typeof (f as { errorCode?: unknown }).errorCode === "string",
    );
  if (!hasRowCodes) return bulk;
  return describeBatchUpdateError(
    translators.tErrors as unknown as Parameters<typeof describeBatchUpdateError>[0],
    err,
    bulk,
  );
}
